export default __webpack_public_path__ + "locales/fi/DeleteThirdPartyDialog.json?hash=8b75e0a1ba3feb7331a3752fc97a17b8";